import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useMediaQuery } from "react-responsive";
import Slider from "react-slick";
import Cookies from "universal-cookie";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import _, { isEmpty } from "lodash";
import RenderItem from "../../common/renderItem";
import MyStorage from "../../common/MyStorage";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
  setAllCategories,
  setAllMerchants,
  setTiles,
  setAllSpecialCategories,
} from "../../redux/actions/postActions";
import cleanURL from "../../common/cleanURL";
import isObjectEmpty from "../../common/isObjectEmpty";
import ThumbItem from "../../common/ThumbItem";
import {
  KMTracking,
  campaignRecord,
} from "../../components/Tracking/KMTracking";
import ContentLoader from "react-content-loader";
import { Link } from "react-router-dom";

const MyLoader = () => (
  <ContentLoader viewBox="0 0 1000 400">
    <rect x="3" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="350" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="700" y="20" rx="4" ry="4" width="300" height="260" />
    <rect x="3" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="350" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="700" y="290" rx="4" ry="4" width="120" height="28" />
    <rect x="3" y="330" rx="4" ry="4" width="175" height="28" />
    <rect x="3" y="371" rx="4" ry="4" width="131" height="33" />
    <rect x="350" y="330" rx="4" ry="4" width="300" height="29" />
    <rect x="350" y="371" rx="4" ry="4" width="116" height="30" />
    <rect x="700" y="330" rx="4" ry="4" width="173" height="29" />
    <rect x="700" y="371" rx="4" ry="4" width="200" height="31" />
  </ContentLoader>
);
function Dashboard(props) {
  const [categories, setCategories] = useState([]);
  const [carouselData, setCarouselData] = useState<any>([]);
  // const [merchants, setMerchants] = useState([])
  const [FromTheEditorText, setFromTheEditorText] = useState<any>({});
  const [featuredProducts, setFeaturedProducts] = useState<any>([]);
  const [featuredProductsID, setfeaturedProductsID] = useState<any>([]);
  const [featuredBrands, setFeaturedBrands] = useState<any>([]);
  const [estore_single_banner, setEstoreSingeBanner] = useState<any>("");
  const [estore_single_banner_nav, setSingleBannerNav] = useState<any>("");
  const [trendingProducts, setTrendingProducts] = useState<any>([]);
  const [trendingData, setTrendingData] = useState<any>([]);
  const [blogList, setBlogList] = useState<any>([]);
  const [blogProducts, setblogProducts] = useState<any>([]);
  const [is_loading, setIsLoading] = useState(true);
  const [popUps, setPopUps] = useState<any>({});
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const isMobileOnly = useMediaQuery({ maxWidth: "600px" });
  const [showCookiesModal, setShowCookiesModal] = useState(true);
  const [swapSection, setSwapSection] = useState<any>({});
  const [featuredData, setFeaturedData] = useState<any>({});
  const [showPopUp, setShowPopUp] = useState<any>(true);
  const [isHover, setIsHover] = useState<any>(false);

  var ACF;
  useEffect(() => {
    props.location.search &&
      campaignRecord(props.location.search, props.location.pathname);

    const data = {
      "Current Page": "eStoreHome",
      Step: "Main home page for eStore website is loaded",
    };
    tracker("pageviewed", data);
    //checkFailedOrder();
    getFeaturedBrands();
    getCategories();
    getPopups();
    getCookies();
    getCarouselBanners();
    getTiles();
    getSettings();
    seeCart();
    const cookiejar = document.querySelector(".cookiejar");
    const cookiejarbtn = document.querySelector(".cookiejar .blackbutton");
    const cookiejarclose = document.querySelector(".cookiejar .close img");
    const cookiejaroverlay = document.querySelector(".cookiejar .overlay");

    setTimeout(function () {
      cookiejar?.classList.add("active");
    }, 1000);
    // pop promo
    const poppromo = document.querySelector(".pop-promo");
    cookiejarbtn?.addEventListener("click", function (event) {
      cookiejar?.classList.remove("active");
    });
    // cookiejarbtn?.addEventListener('click', function (event) {
    // 	cookiejar?.classList.remove('active');
    poppromo?.classList.add("active");
    // })

    cookiejarclose?.addEventListener("click", function (event) {
      cookiejar?.classList.remove("active");
    });

    cookiejaroverlay?.addEventListener("click", function (event) {
      cookiejar?.classList.remove("active");
    });

    const mainoverlay = document.querySelector(".main-overlay");

    // setTimeout(function(){
    // 	poppromo.classList.add('active');
    // }, 1000);

    const poppromoclose = document.querySelector(".pop-promo .close");
    const poppromooverlay = document.querySelector(".pop-promo .overlay");

    poppromoclose?.addEventListener("click", function (event) {
      poppromo?.classList.remove("active");
    });

    poppromooverlay?.addEventListener("click", function (event) {
      poppromo?.classList.remove("active");
    });
    return () => {};
  }, []);
  useEffect(() => {
    let isShown = window.sessionStorage.getItem("isPopUpShown");
    let popUpFrequency = window.sessionStorage.getItem("popUpFrequency");
    if (!isEmpty(popUps)) {
      if (
        popUps.frequency == "null" ||
        popUps.frequency == null ||
        popUps.frequency == "-1"
      ) {
        setShowPopUp(false);
      } else if (!isShown) {
        let freq = popUps?.frequency ? Number(popUps.frequency) - 1 : -1;
        window.sessionStorage.setItem("popUpFrequency", freq.toString());
        window.sessionStorage.setItem("isPopUpShown", "true");
        setShowPopUp(true);
      } else if (isShown) {
        if (popUpFrequency) {
          let freq = Number(popUpFrequency) - 1;
          if (freq < 0) {
            setShowPopUp(false);
          } else {
            window.sessionStorage.setItem("popUpFrequency", freq.toString());
            window.sessionStorage.setItem("isPopUpShown", "true");
            setShowPopUp(true);
          }
        } else {
          setShowPopUp(false);
        }
      }
    }
  }, [popUps]);

  const checkFailedOrder = async () => {
    if (window.location.search) {
      let query = window.location.search;
      let splitingQuerry = query.split("&");
      let status = splitingQuerry[0].split("=")[1];
      let InVoiceID = splitingQuerry[1].split("=")[1];
      let userID = await localStorage.getItem("UserId");
      let accessToken = await localStorage.getItem("access_token");
      if (status.includes("failure")) {
        new WebApiCalls()
          .getALlInvoices(userID, accessToken, 1, 10, false, InVoiceID)
          .then((_response) => {
            if (_response.Records && _response.Records.length > 0) {
              let order_quantity = 0;
              let kmViewedProps = {
                "Order Confirmation No": _response.Records[0].InvoiceNo,
                Currency: _response.Records[0].CurrencyCode,
                "Total discount": "",
                "Coupon code": "",
                Fulfilment:
                  _response.Records[0].Orders[0].CustomFields !== null
                    ? _response.Records[0].Orders[0].CustomFields.filter(
                        (item) => item.Name.includes("CustomOrderType")
                      ).length > 0
                      ? _response.Records[0].Orders[0].CustomFields.filter(
                          (item) => item.Name.includes("CustomOrderType")
                        )[0].Values[0]
                      : ""
                    : "delivery",
              };
              _response.Records[0].Orders.map((item, index) => {
                item.CartItemDetails.map((i, j) => {
                  order_quantity = order_quantity + parseInt(i.Quantity);
                });
              });
              kmViewedProps["Product quantity"] = order_quantity;
              tracker("failedorder", kmViewedProps);
            }
          });
        return;
      } else {
        console.log("Status is: ", status);
        props?.history?.push(`/order-details/${InVoiceID}`);
      }
    }
  };
  const getCategories = async () => {
    await new WebApiCalls().getAllCategoriesByHerarchy().then((response) => {
      if (response) {
        let tempCategories: any = [];
        response?.map((item) => {
          if (item?.Description !== "hidden") {
            tempCategories = [...tempCategories, item];
          }
        });
        setCategories(tempCategories);
        props?.setAllCategories(tempCategories);
        props?.setAllSpecialCategories(response);
      }
    });
  };
  const getFeaturedBrands = async () => {
    await new WebApiCalls().getFeaturedBrands().then((response) => {
      if (response?.data?.length > 0) {
        let brands1 = response?.data[0];
        let brandsData = JSON.parse(response?.data[0]?.brands);
        brandsData = brandsData?.sort((a, b) => {
          return a.sort - b.sort;
        });
        brands1.brands = brandsData;
        setFeaturedBrands(brands1);
      }
    });
  };
  const getPopups = async () => {
    await new WebApiCalls().getPopOvers().then((response) => {
      let popups: any = response?.data;
      if (popups?.length > 0) {
        popups = popups?.sort((a, b) => {
          return (
            new Date(b.published_at).getTime() -
            new Date(a.published_at).getTime()
          );
        });
        popups.reverse();
        let item = popups[0];
        if (item?.name == "eStore Home Popup") {
          let deeplink = JSON.parse(item?.deeplink);
          item.deeplink = deeplink;
          setPopUps(item);
        }
      }
    });
  };
  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  const seeCart = async () => {
    const storage = new MyStorage();
    const login = storage.getloggedIn();
    if (!login || login == "false") {
      return;
    }
    const localStorage = new MyStorage();
    // this.setState({ cartSpinner: true });
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    if (userID && accessToken) {
      await new WebApiCalls()
        .getCartDetail(userID, accessToken)
        .then(async (Response) => {
          if (Response?.body?.length == 0) {
            return;
          } else if (Response.statusCode === 200) {
            await new WebApiCalls()
              .seeCart(userID, accessToken)
              .then(async (response) => {
                let a: any = 0;
                let b: any = 0;
                a = response.Records.map((item) => {
                  return parseInt(a + item.Quantity);
                });
                a.map((aitem) => {
                  b = b + aitem;
                });
                let total = 0;
                let itemID: any = [];
                await response.Records.map(async (item) => {
                  total = total + item.SubTotal;
                  itemID.push(item.ID);
                  let obj = {
                    ID: item.ItemDetail.ID,
                  };
                  localStorage.setCartAmount(total);
                  localStorage.setCartCount(b);
                  props.UpdateCartAmount(total);
                  props.UpdateCartCount(b);
                });
              });
          }
        });
    }
  };
  //All comments here

  const TrendingProductsSet = async (trendingProductsList1) => {
    let trendingProductsList = trendingProductsList1;
    if (!_.isEmpty(props?.acf)) {
      ACF = props?.acf;
    } else {
      ACF = await new WebApiCalls().getCustomFieldsCode(true);
      props.setACF(ACF);
    }
    let customFieldQueries;
    if (ACF["Trending"] !== undefined) {
      customFieldQueries = [
        {
          Code: ACF["Trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    } else {
      customFieldQueries = [
        {
          Code: ACF["trending"],
          Operator: "equal",
          Value: "1",
        },
      ];
    }

    let tempArr: any = [];
    let itemObj = {
      CustomFieldQueries: customFieldQueries,
      Sort: "name",
      PageSize: 1000,
    };
    let accessToken = await localStorage.getItem("access_token");
    await new WebApiCalls()
      .getItemsByFilters(itemObj, accessToken)
      .then((_response) => {
        if (_response?.Records) {
          tempArr = _response.Records;
        }
      })
      .catch((error) => console.log("Error: ", error));
    // console.log("here is the trending product data (---temp array---)",tempArr)
    tempArr.map((item, index) => {
      if (
        item?.AddOns?.length < 1 &&
        item?.StockLimited &&
        item?.StockQuantity < 1
      ) {
        tempArr.splice(index, 1);
      }
    });
    let trendingTemp: any = trendingProductsList;
    // trendingProductsList?.map((item) => {
    //   let temp = tempArr.filter((item2) => {
    //     return item2.ID == item.ID;
    //   });
    //   if (temp?.length > 0) {
    //     temp[0].sort = item?.sort;
    //   }
    //   trendingTemp.push(temp[0]);
    // });
    console.log(
      "here is the trending product data list new---->",
      trendingTemp
    );
    trendingTemp = trendingTemp.filter((item) => {
      return (
        (item?.StockLimited && item?.StockQuantity > 0) ||
        item?.StockLimited == false ||
        item?.AddOns?.length > 0
      );
    });
    console.log(
      "here is the trending product data list new---->(2)",
      trendingTemp
    );
    trendingTemp = trendingTemp.sort((a, b) => {
      return a.sort - b.sort;
    });
    trendingTemp?.length > 0 &&
      trendingTemp?.map((item) => {
        let index = tempArr?.indexOf(item);
        tempArr?.splice(index, 1);
      });
    if (trendingTemp?.length < 4) {
      let productsToAdd = 4 - trendingTemp?.length;
      let backupProducts = tempArr?.slice(0, productsToAdd);
      backupProducts?.length > 0 &&
        backupProducts?.map((item) => {
          trendingTemp = [...trendingTemp, item];
        });
      console.log(
        "here is the trending product data set inside setTrending function--->",
        trendingTemp
      );
    }
    setTrendingProducts(trendingTemp);
  };
  const getCarouselBanners = () => {
    let bannerData: any = [];
    new WebApiCalls().getCarouselBanners().then((result) => {
      if (result.statusCode == 200 && result?.data?.Items) {
        result.data.Items.map((item: any) => {
          if (item.item_status == "Y" && item.page == "estore") {
            bannerData = [...bannerData, item];
          }
        });
      }
      setCarouselData(bannerData);
    });
  };
  const getTiles = async () => {
    try {
      let blogTempArr: any = [];
      if (props?.tiles.length > 0) {
        let filteredSingleBanners = props?.tiles?.filter(
          (item) => item.page == "estore_single"
        );
        let sortedMini = filteredSingleBanners.sort((a, b) => {
          if (a.sort_order != b.sort_order) {
            return a.sort_order - b.sort_order;
          } else {
            return (
              new Date(b.published_at).getTime() -
              new Date(a.published_at).getTime()
            );
          }
        });
        if (sortedMini?.length > 0) {
          let item = sortedMini[0];
          if (
            item.item_status == "Y" &&
            item.page == "estore_single" &&
            item?.sort_order == 1
          ) {
            setEstoreSingeBanner(item.image_url);
            setSingleBannerNav(JSON.parse(item.deeplink));
          }
        }
        props?.tiles.map((item: any) => {
          if (item.item_status == "Y" && item.page == "estore_blog") {
            blogTempArr.push(item);
          }
          if (item.page == "estore_trending_single") {
          }
        });
      } else {
        await new WebApiCalls()
          .getTiles()
          .then((result) => {
            if (result && result.data && result.data && result.data.Items) {
              props?.setTiles(result.data.Items);
              let filteredSingleBanners = result.data.Items?.filter(
                (item) => item.page == "estore_single"
              );
              let sortedMini = filteredSingleBanners.sort((a, b) => {
                if (a.sort_order != b.sort_order) {
                  return a.sort_order - b.sort_order;
                } else {
                  return (
                    new Date(b.published_at).getTime() -
                    new Date(a.published_at).getTime()
                  );
                }
              });
              if (sortedMini?.length > 0) {
                let item = sortedMini[0];
                if (
                  item.item_status == "Y" &&
                  item.page == "estore_single" &&
                  item?.sort_order == 1
                ) {
                  setEstoreSingeBanner(item.image_url);
                  setSingleBannerNav(JSON.parse(item.deeplink));
                }
              }
              result.data.Items.map((item: any) => {
                if (item.item_status == "Y" && item.page == "estore_blog") {
                  blogTempArr.push(item);
                }
                if (item.page == "estore_trending_single") {
                }
              });
            } else {
            }
          })
          .catch((error) => {
            console.log("catch error ", error);
          });
      }
      // let deeplink = parsedDeeplink.params
      let sortedArray = blogTempArr.sort((a, b) => {
        if (a.sort_order != b.sort_order) {
          return a.sort_order - b.sort_order;
        } else {
          return (
            new Date(b.published_at).getTime() -
            new Date(a.published_at).getTime()
          );
        }
      });
      let parsedDeeplink = JSON.parse(sortedArray[0]?.deeplink);
      getBlogProducts(parsedDeeplink);
      setBlogList(sortedArray);
      setIsLoading(false);
    } catch (e) {
      console.log("error is", e);
    }
  };
  const getSettings = async () => {
    await new WebApiCalls().getSettings().then((_response) => {
      if (_response.data) {
        if (_response.data.Items.length > 0) {
          _response.data.Items.map((item) => {
            item.item_name = item.item_name ? item.item_name : "";
            if (item.item_name.includes("FromTheEditorText")) {
              setFromTheEditorText(item);
            }
            if (item.item_name.includes("swap_web_trending")) {
              setSwapSection(JSON.parse(item.item_detail));
            }
            if (item.item_name.includes("featuredProducts")) {
              const itemDetail = JSON.parse(item?.item_detail);
              setFeaturedData(itemDetail);
              let productsArr = itemDetail?.products;
              productsArr = productsArr?.filter((item) => item?.value !== "");
              productsArr = productsArr?.sort((a, b) => {
                return a.sort - b.sort;
              });
              setFeaturedProducts(productsArr);
            }
            if (item.item_name.includes("trendingProducts")) {
              const itemDetail = JSON.parse(item?.item_detail);
              console.log(
                "here is the trending product data----->",
                itemDetail
              );
              setTrendingData(itemDetail);
              let productsArr = itemDetail?.products;
              productsArr = productsArr?.filter((item) => item?.value !== "");
              productsArr = productsArr?.sort((a, b) => {
                return a.sort - b.sort;
              });
              console.log(
                "here is the trending product data sortted----->",
                productsArr
              );
              TrendingProductsSet(productsArr);
              // getTrendingProducts(productsArr);
            }
          });
        }
      }
    });
  };
  const getBlogProducts = async (deeplink) => {
    if (deeplink?.products?.length > 0) {
      let _products = deeplink?.products;
      let product: any = [];
      _products?.length > 0 &&
        _products?.map(async (item) => {
          if (item.value !== "") {
            new WebApiCalls().getSingleItem(item.value).then((response) => {
              if (response.ID) {
                response.sort = item.sort;
                product.push(response);
              }
            });
          }
        });
      setTimeout(() => {
        setblogProducts(_.sortBy(product, "sort"));
      }, 1500);
    }
  };

  const renderSlider = () => {
    let sortedArray = carouselData.sort((a, b) => {
      if (a.sort_order != b.sort_order) {
        return a.sort_order - b.sort_order;
      } else {
        return (
          new Date(b.published_at).getTime() -
          new Date(a.published_at).getTime()
        );
      }
    });

    let settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      centerMode: false,
      nextArrow: <NextArrow isBanner={true} />,
      prevArrow: <PrevArrow isBanner={true} />,
    };
    return (
      <Slider {...settings}>
        {sortedArray?.map((item: any, index: number) => {
          return isObjectEmpty(JSON.parse(item.navigate_to)?.website_params) ? (
            <div key={index} style={{ width: "100%" }}>
              <img
                onMouseOver={(e) => {
                  if (
                    isObjectEmpty(JSON.parse(item.navigate_to)?.website_params)
                  ) {
                    setIsHover(true);
                  } else {
                    setIsHover(false);
                  }
                }}
                style={{ width: "100%", cursor: "context-menu" }}
                src={item?.image_url}
                alt=""
              />
            </div>
          ) : (
            <Link
              key={index}
              style={{ width: "100%" }}
              to={{
                pathname: isObjectEmpty(
                  JSON.parse(item.navigate_to)?.website_params
                )
                  ? "javascript:void(0)"
                  : JSON.parse(item.navigate_to)?.params?.hidden == true
                  ? `/categories-listing/${cleanURL(
                      JSON.parse(item.navigate_to)?.params?.cat_name
                    )}/${JSON.parse(item.navigate_to)?.params?.ID}`
                  : `${
                      new URL(
                        JSON.parse(item.navigate_to).website_params.nav_to
                      ).pathname
                    }`,
                search: isObjectEmpty(
                  JSON.parse(item.navigate_to)?.website_params
                )
                  ? ""
                  : `?Medium=${
                      JSON.parse(item.navigate_to)?.params?.CampaignMedium
                    }&link=${JSON.parse(item.navigate_to)?.params?.link}`,
                state: { from: "Home" },
              }}
            >
              <img
                onMouseOver={(e) => {
                  if (
                    isObjectEmpty(JSON.parse(item.navigate_to)?.website_params)
                  ) {
                    setIsHover(true);
                  } else {
                    setIsHover(false);
                  }
                }}
                style={{ width: "100%", cursor: "pointer" }}
                src={item?.image_url}
                alt=""
              />
            </Link>
          );
        })}
      </Slider>
    );
  };
  function NextArrow(props) {
    const { className, style, onClick, isBanner } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "rgba(255, 255, 255, 0.5)",
          top: isBanner ? "50%" : "31%",
          marginRight: isBanner ? "0px" : "10px",
          opacity: 1,
        }}
        onClick={onClick}
      >
        <div className="slick-next">
          <img src="images/next.png" />
        </div>
      </div>
    );
  }

  function PrevArrow(props) {
    const { className, style, onClick, isBanner } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "rgba(255, 255, 255, 0.5)",
          top: isBanner ? "50%" : "31%",
          marginLeft: isBanner ? "0px" : "10px",
          opacity: 1,
        }}
        onClick={onClick}
      >
        <div className="slick-prev">
          <img src="images/prev.png" />
        </div>
      </div>
    );
  }
  const renderMiniSlider = (
    imgArray: any,
    slides: number,
    button_text: string,
    nav: any
  ) => {
    if (imgArray == trendingProducts) {
      console.log(
        "here is the trending product data comming inside render slider---->",
        imgArray
      );
    }

    let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: slides,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 3000,
      centerMode: false,
      nextArrow: <NextArrow isBanner={false} />,
      prevArrow: <PrevArrow isBanner={false} />,
    };
    return (
      <Slider {...settings}>
        {imgArray?.length > 0 &&
          imgArray?.map((item: any, index: number) => {
            if (!item?.ID || !item?.IsAvailable) {
              return;
            }
            return (
              <RenderItem
                key={index}
                item={item}
                onClickItem={onClickItem}
                is_slider={true}
                from={"Home"}
              />
            );
          })}
        {/* <div> */}
        <ThumbItem
          button_text={button_text.toUpperCase()}
          onClickItem={() => {
            props?.history?.push(nav, { from: "Home" });
          }}
          nav={nav}
          from={"Home"}
        />
        {/* </div> */}
      </Slider>
    );
  };
  const onClickItem = (_item) => {
    props?.history?.push(`/product/${cleanURL(_item.Name)}/${_item.ID}`, {
      from: "Home",
    });
  };
  const createBlogItem = (blog_number: number) => {
    if (!blogList[blog_number]) return;
    let deeplink = JSON.parse(blogList[blog_number].deeplink);
    return (
      <Link
        className="promo"
        style={{ textDecoration: "none" }} //marginBottom: isMobileOnly && 0, marginTop: isMobileOnly&& 40
        to={{
          pathname:
            deeplink?.section == "/blog"
              ? `/blog/${deeplink?.params?.blog_id}/${cleanURL(
                  deeplink?.params?.title
                )}`
              : deeplink?.params?.comingFromStore
              ? `/brand/${cleanURL(deeplink?.params?.cat_name)}/${
                  deeplink?.params?.ID
                }`
              : deeplink?.params?.hidden
              ? `/categories-listing/${cleanURL(deeplink?.params?.cat_name)}/${
                  deeplink?.params?.ID
                }`
              : `category/${cleanURL(deeplink?.params?.cat_name)}/${
                  deeplink?.params?.ID
                }`,

          search: `?Medium=${deeplink?.params?.CampaignMedium}&link=${deeplink?.params?.link}`,
          state: { from: "Home" },
        }}
      >
        <img src={blogList[blog_number]?.image_url} />

        {/* /callingaction*/}
        {/* <div className="double-highlights"></div> */}
        <div className="callaction">
          {" "}
          {/*Added by me */}
          <div className="">
            <div className="title" style={{ color: "#333" }}>
              {deeplink?.params?.title}
            </div>
            <div className="text" style={{ color: "#666" }}>
              {deeplink?.params?.summary}
            </div>
          </div>
        </div>
        {/* /callingaction*/}

        <div className="blackbtn-wrap">
          <div className="blackbutton">{deeplink?.params?.button_text}</div>
        </div>
      </Link>
    );
  };
  const blogZeroDetails = (blog_number: number) => {
    if (!blogList[blog_number]) return;
    let deeplink = JSON.parse(blogList[blog_number].deeplink);
    const nav = deeplink?.website_params?.nav_to;
    return (
      <div className="description">
        <div className="callaction">
          <div className="title">{deeplink?.params?.title}</div>
          <div className="text">{deeplink?.params?.summary}</div>
        </div>
        {/* /minicarousel*/}
        {is_loading ? (
          <MyLoader />
        ) : (
          <div className="minicarousel two" style={{ marginTop: 0 }}>
            {" "}
            {/*Style added here */}
            {/* item */}
            {deeplink?.section == "/blog"
              ? renderMiniSlider(
                  blogProducts,
                  2,
                  "SHOP ALL PRODUCTS",
                  `/blog/${deeplink?.params?.blog_id}/${deeplink?.params?.title}`
                )
              : deeplink?.params?.comingFromStore == true
              ? renderMiniSlider(
                  blogProducts,
                  2,
                  "SHOP ALL PRODUCTS",
                  `/brand/${cleanURL(deeplink?.params?.cat_name)}/${
                    deeplink?.params?.ID
                  }`
                )
              : deeplink?.params?.hidden == true
              ? renderMiniSlider(
                  blogProducts,
                  2,
                  "SHOP ALL PRODUCTS",
                  `/categories-listing/${cleanURL(
                    deeplink?.params?.cat_name
                  )}/${deeplink?.params?.ID}?Medium=${
                    deeplink?.params?.CampaignMedium
                  }&link=${deeplink?.params?.link}`
                )
              : renderMiniSlider(
                  blogProducts,
                  2,
                  "SHOP ALL PRODUCTS",
                  `/category/${cleanURL(deeplink?.params?.cat_name)}/${
                    deeplink?.params?.ID
                  }`
                )}
            {/* /item last */}
          </div>
        )}
        {/* /minicarousel*/}
        <Link
          className="blackbutton"
          to={{
            pathname:
              deeplink?.section == "/blog"
                ? `/blog/${deeplink?.params?.blog_id}?Medium=${deeplink?.params?.CampaignMedium}&link=${deeplink?.params?.link}`
                : deeplink?.params?.comingFromStore == true
                ? `/brand/${cleanURL(deeplink?.params?.cat_name)}/${
                    deeplink?.params?.ID
                  }?Medium=${deeplink?.params?.CampaignMedium}&link=${
                    deeplink?.params?.link
                  }`
                : deeplink?.params?.hidden == true
                ? `/categories-listing/${cleanURL(
                    deeplink?.params?.cat_name
                  )}/${deeplink?.params?.ID}?Medium=${
                    deeplink?.params?.CampaignMedium
                  }&link=${deeplink?.params?.link}`
                : `category/${cleanURL(deeplink?.params?.cat_name)}/${
                    deeplink?.params?.ID
                  }?Medium=${deeplink?.params?.CampaignMedium}&link=${
                    deeplink?.params?.link
                  }`,

            search: "",

            state: { from: "Home" },
          }}
        >
          {deeplink?.params?.button_text}
        </Link>
      </div>
    );
  };
  const onAcceptCokkies = () => {
    const cookies = new Cookies();

    // cookies.set('frasersTest', 'frasersTest', { path: '/' });
    console.log(cookies.get("frasersTest"));
    var oneYear = new Date();
    oneYear.setDate(oneYear.getDate() + 364);
    // console.log("here is the expire date--->",oneYear)
    cookies.set("token", "token-value", {
      expires: oneYear,
    });
  };

  const getCookies = () => {
    const cookies = new Cookies();
    let cookie = cookies.get("token");
    // console.log("here come the cookies after set token---->",cookie)
    if (cookie) {
      setShowCookiesModal(false);
    }
  };
  let count = 0;
  return (
    <div>
      <div className="viewport"></div>

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        <MenuBar props={props} categoriesArray={categories ? categories : []} />

        {/* /carousel */}
        <div className="carousel">{renderSlider()}</div>
        {/* /carousel */}

        {/* /content */}
        <div className="content">
          {swapSection.trending == 1 &&
          trendingProducts.length > 0 &&
          !isEmpty(trendingData) ? (
            <section className="info1">
              <div className="callaction">
                <div className="">
                  <div className="title">{trendingData?.title} </div>
                  <div className="text">{trendingData?.blurb}</div>
                </div>

                <Link
                  className="blackbutton desktop-inline"
                  to={{
                    pathname: `/categories-listing/${"trending"}`,
                    state: { from: "Home" },
                  }}
                >
                  {trendingData?.button_text}
                </Link>
              </div>
              <div className="minicarousel three">
                {isTabletOrMobile || isTabletOrMobileDevice
                  ? renderMiniSlider(
                      trendingProducts,
                      2,
                      "SHOP ALL PRODUCTS",
                      "/categories-listing/trending"
                    )
                  : renderMiniSlider(
                      trendingProducts,
                      3,
                      "SHOP ALL PRODUCTS",
                      "/categories-listing/trending"
                    )}
              </div>
              <Link
                to={{
                  pathname: `/categories-listing/${"trending"}`,
                  state: { from: "Home" },
                }}
                className="blackbutton mobile-only"
              >
                {trendingData?.button_text}
              </Link>
            </section>
          ) : (
            !_.isEmpty(featuredData) &&
            swapSection.Editor == 1 &&
            featuredProducts.length > 0 && (
              <section className="info1">
                <div className="callaction">
                  <div className="">
                    <div className="title">{featuredData?.title}</div>
                    <div className="text">{featuredData?.blurb}</div>
                  </div>
                  <Link
                    to={{
                      pathname: `/categories-listing/${"featured"}`,
                      state: { from: "Home" },
                    }}
                    className="blackbutton desktop-inline"
                  >
                    {featuredData?.button_text}
                  </Link>
                </div>
                <div className="minicarousel three">
                  {isTabletOrMobile || isTabletOrMobileDevice
                    ? renderMiniSlider(
                        featuredProducts,
                        2,
                        "SHOP ALL PRODUCTS",
                        "/categories-listing/featured"
                      )
                    : renderMiniSlider(
                        featuredProducts,
                        3,
                        "SHOP ALL PRODUCTS",
                        "/categories-listing/featured"
                      )}
                </div>

                <Link
                  className="blackbutton mobile-only"
                  to={{
                    pathname: `/categories-listing/${"featured"}`,
                    state: { from: "Home" },
                  }}
                >
                  {featuredData?.button_text}
                </Link>
              </section>
            )
          )}
          {/* /info 1 */}

          {/* info 2 */}
          {blogList[0] && (
            <section className="info2">
              <div className="example">
                <Link
                  style={{ cursor: "pointer" }}
                  to={{
                    pathname:
                      JSON.parse(blogList[0].deeplink)?.section == "/blog"
                        ? `/blog/${
                            JSON.parse(blogList[0].deeplink)?.params?.blog_id
                          }/${cleanURL(
                            JSON.parse(blogList[0].deeplink)?.params?.title
                          )}`
                        : JSON.parse(blogList[0].deeplink)?.params
                            ?.comingFromStore == true
                        ? `/brand/${cleanURL(
                            JSON.parse(blogList[0].deeplink)?.params?.cat_name
                          )}/${JSON.parse(blogList[0].deeplink)?.params?.ID}`
                        : JSON.parse(blogList[0].deeplink)?.params?.hidden ==
                          true
                        ? `/categories-listing/${cleanURL(
                            JSON.parse(blogList[0].deeplink)?.params?.cat_name
                          )}/${JSON.parse(blogList[0].deeplink)?.params?.ID}`
                        : `/category/${cleanURL(
                            JSON.parse(blogList[0].deeplink)?.params?.cat_name
                          )}/${JSON.parse(blogList[0].deeplink)?.params?.ID}`,

                    search: `?Medium=${
                      JSON.parse(blogList[0].deeplink)?.params?.CampaignMedium
                    }&link=${JSON.parse(blogList[0].deeplink)?.params?.link}`,
                    state: { from: "Home" },
                  }}
                >
                  <img src={blogList[0]?.image_url} />
                </Link>
              </div>

              {blogZeroDetails(0)}
            </section>
          )}
          {/* /info 2 */}

          {/* /banner*/}
          <div className="banner">
            {estore_single_banner !== "" && (
              <Link
                to={{
                  pathname:
                    estore_single_banner_nav?.website_params?.nav_to?.split(
                      ".com/"
                    )[1],
                  search: ``,
                  // pathname: estore_single_banner_nav?.section == "/blog" ? `/blog/${estore_single_banner_nav?.params?.ID}/${cleanURL(estore_single_banner_nav?.params?.blog_name)}?Medium=${estore_single_banner_nav?.params?.CampaignMedium}&link=${estore_single_banner_nav?.params?.link}` :
                  // 	estore_single_banner_nav?.params?.comingFromStore == true ? `/brand/${cleanURL(estore_single_banner_nav?.params?.cat_name)}/${estore_single_banner_nav?.params?.ID}?Medium=${estore_single_banner_nav?.params?.CampaignMedium}&link=${estore_single_banner_nav?.params?.link}` :
                  // 		estore_single_banner_nav?.params?.hidden == true ? `/categories-listing/${cleanURL(estore_single_banner_nav?.params?.cat_name)}/${estore_single_banner_nav?.params?.ID}?Medium=${estore_single_banner_nav?.params?.CampaignMedium}&link=${estore_single_banner_nav?.params?.link}` :
                  // 			isEmpty(estore_single_banner_nav.website_params) ? '' : `/category/${cleanURL(estore_single_banner_nav?.params?.cat_name)}/${estore_single_banner_nav?.params?.ID}?Medium=${estore_single_banner_nav?.params?.CampaignMedium}&link=${estore_single_banner_nav?.params?.link}`,
                  state: { from: "Home" },
                }}
              >
                <img src={estore_single_banner} />
              </Link>
            )}
          </div>
          {/* /banner*/}

          {/* info 1 */}
          {!_.isEmpty(FromTheEditorText) &&
          swapSection.Editor == 2 &&
          featuredProducts.length > 0 ? (
            <section className="info1">
              {/* /callingaction*/}
              <div className="callaction">
                <div className="">
                  <div className="title">{featuredData?.title} </div>
                  <div className="text">{featuredData?.blurb}</div>
                </div>
                <Link
                  to={{
                    pathname: `/categories-listing/${"featured"}`,
                    state: { from: "Home" },
                  }}
                  className="blackbutton desktop-inline"
                >
                  {featuredData?.button_text}
                </Link>
              </div>
              {/* /callingaction*/}

              {/* /minicarousel*/}
              <div className="minicarousel three">
                {/* /item*/}
                {isTabletOrMobile || isTabletOrMobileDevice
                  ? renderMiniSlider(
                      featuredProducts,
                      2,
                      "SHOP ALL PRODUCTS",
                      "/categories-listing/featured"
                    )
                  : renderMiniSlider(
                      featuredProducts,
                      3,
                      "SHOP ALL PRODUCTS",
                      "/categories-listing/featured"
                    )}
                {/* /item last*/}
              </div>
              {/* /minicarousel*/}

              <Link
                className="blackbutton mobile-only"
                to={{
                  pathname: `/categories-listing/${"featured"}`,
                  state: { from: "Home" },
                }}
              >
                {featuredData?.button_text}
              </Link>
            </section>
          ) : (
            trendingProducts.length > 0 &&
            swapSection.trending == 2 && (
              <section className="info1">
                <div className="callaction">
                  <div className="">
                    <div className="title">{trendingData?.title}</div>
                    <div className="text">{trendingData?.blurb}</div>
                  </div>
                  <Link
                    className="blackbutton desktop-inline"
                    to={{
                      pathname: `/categories-listing/${"trending"}`,
                      state: { from: "Home" },
                    }}
                  >
                    {trendingData?.button_text}
                  </Link>
                </div>
                <div className="minicarousel three">
                  {isTabletOrMobile || isTabletOrMobileDevice
                    ? renderMiniSlider(
                        trendingProducts,
                        2,
                        "SHOP ALL PRODUCTS",
                        "/categories-listing/trending"
                      )
                    : renderMiniSlider(
                        trendingProducts,
                        3,
                        "SHOP ALL PRODUCTS",
                        "/categories-listing/trending"
                      )}
                </div>
                <Link
                  className="blackbutton mobile-only"
                  to={{
                    pathname: `/categories-listing/${"trending"}`,
                    state: { from: "Home" },
                  }}
                >
                  {trendingData?.button_text}
                </Link>
              </section>
            )
          )}
          {/* /info 1 */}

          {/* double highlights */}
          {blogList.length <= 2 ? (
            <div className="double-highlights">
              {createBlogItem(1)}
              {createBlogItem(2)}
            </div>
          ) : (
            <div>
              <div className="double-highlights">
                {createBlogItem(1)}
                {createBlogItem(2)}
              </div>
              <div className="double-highlights">
                {createBlogItem(3)}
                {createBlogItem(4)}
              </div>
            </div>
          )}
          {console.log("Blog list numbers:	", blogList)}
          {/* <div className="double-highlights">
						{createBlogItem(3)}
						{createBlogItem(4)}
					</div> */}
          {/* /double highlights */}

          {/* /featuredbrands*/}
          {!isEmpty(featuredBrands) && (
            <div className="featured">
              {/* style added by me*/}
              <div className="title">{featuredBrands?.title}</div>

              {/*brand */}
              {featuredBrands?.brands?.length > 5 &&
                featuredBrands?.brands?.map((item: any, index) => {
                  if (item?.DisplayName == "FRx Delivery") {
                    return;
                  }
                  if (item?.BannerURL == "") {
                    return;
                  }
                  count = count + 1;
                  if (count <= 6) {
                    return (
                      <div key={index} className="brand">
                        <Link
                          style={{ textDecoration: "none" }}
                          to={{
                            pathname: `/brand/${cleanURL(item?.DisplayName)}/${
                              item?.ID
                            }`,
                            state: { from: "Home" },
                          }}
                        >
                          <img src={item?.image} />
                        </Link>
                        <div className="brandname">{item?.DisplayName}</div>
                      </div>
                    );
                  }
                })}
              <Link
                className="blackbutton"
                to={{ pathname: "/brands-list", state: { from: "Home" } }}
              >
                {featuredBrands?.btn_text}
              </Link>
            </div>
          )}
        </div>
      </div>
      {/* /container */}

      <Footer categoriesArray={categories ? categories : []} props={props} />

      {/* cookiejar */}
      {showCookiesModal && (
        <div className="cookiejar">
          {/* message */}
          <div className="message">
            <div className="title">COOKIES AND PRIVACY</div>
            <div className="text">
              To give you the best possible experience, this site uses cookies.
              If you continue browsing, you accept our use of cookies. You can
              review our privacy policy to find out more about the cookies we
              use.
            </div>
            <a className="blackbutton" onClick={onAcceptCokkies}>
              Accept All Cookies
            </a>
            <a className="close">
              <img src="images/icon-x.svg" alt="" />
            </a>
          </div>
          {/* /message */}

          <div className="overlay"></div>
        </div>
      )}
      {/* /cookiejar */}

      {/* pop-promo */}
      {showPopUp ? (
        <div className="pop-promo">
          {/* boxwrap */}
          <div className="boxwrap">
            <div className="thumb">
              <img src={popUps?.image} alt="" />
            </div>
            {!isEmpty(popUps) && (
              <div className="details">
                <div className="title">{popUps?.deeplink?.title}</div>
                <div className="text">{popUps?.deeplink?.blurb}</div>
                <a href={`${popUps?.deeplink?.nav_to}`} className="blackbutton">
                  {popUps?.deeplink?.button_text}
                </a>
              </div>
            )}

            <a className="close">
              <img src="images/icon-x.svg" alt="" />
            </a>
          </div>
          {/* /boxwrap */}

          <div className="overlay"></div>
        </div>
      ) : null}
      <a onClick={() => window.scrollTo(0, 0)} className="btt">
        <img src="images/uparrow.svg" alt="" />
      </a>
      {/* /pop-promo */}
    </div>
  );
}
const mapStateToProps = (state) => {
  const {
    cart_count,
    acf,
    allCategories,
    allMerchants,
    allSpecialCategories,
    tiles,
  } = state.UserReducer;
  return {
    cart_count,
    acf,
    allCategories,
    allSpecialCategories,
    allMerchants,
    tiles,
  };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
  setAllCategories,
  setAllSpecialCategories,
  setAllMerchants,
  setTiles,
};
export default connect(mapStateToProps, actions)(Dashboard);
